import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import Registry from "@core/registry";
import { PrivatePlatformClient, HttpStatusCodes } from "@coveo-platform/private-platform-client";
var VITAL_FETCH_URLS = new RegExp("^.*/rest/((organizations/\\w*/license(\\?.*)?)|(organizations/\\w*)|(tokens/[\\w-]*/info))$");
var outOfService = {
    canProcess: function(param) {
        var status = param.status, url = param.url;
        var unknownNetworkError = status === 0 && navigator.onLine;
        var platformError = status === HttpStatusCodes.SERVICE_UNAVAILABLE;
        var platformUnreachable = status === HttpStatusCodes.GATEWAY_TIMEOUT;
        var platformVitalFetchError = status === HttpStatusCodes.INTERNAL_SERVER_ERROR && VITAL_FETCH_URLS.test(url);
        return unknownNetworkError || platformError || platformUnreachable || platformVitalFetchError;
    },
    process: function() {
        var _ref = _async_to_generator(function(response) {
            var event, error, _tmp;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event = new Event("helpers:show-out-of-service", {
                            bubbles: true
                        });
                        document.dispatchEvent(event);
                        window["admin"].vent.trigger("helpers:show-out-of-service");
                        _tmp = [
                            {}
                        ];
                        return [
                            4,
                            response.json()
                        ];
                    case 1:
                        error = _object_spread_props.apply(void 0, [
                            _object_spread.apply(void 0, _tmp.concat([
                                _state.sent()
                            ])),
                            {
                                status: response.status,
                                url: response.url
                            }
                        ]);
                        throw error;
                }
            });
        });
        return function(response) {
            return _ref.apply(this, arguments);
        };
    }()
};
var offline = {
    canProcess: function(param) {
        var status = param.status;
        return status === 0 && !navigator.onLine;
    },
    process: function() {
        var _ref = _async_to_generator(function(response) {
            var event, error, _tmp;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event = new Event("connection:offline", {
                            bubbles: true
                        });
                        document.dispatchEvent(event);
                        window["admin"].vent.trigger("connection:offline");
                        _tmp = [
                            {}
                        ];
                        return [
                            4,
                            response.json()
                        ];
                    case 1:
                        error = _object_spread_props.apply(void 0, [
                            _object_spread.apply(void 0, _tmp.concat([
                                _state.sent()
                            ])),
                            {
                                status: response.status,
                                url: response.url
                            }
                        ]);
                        throw error;
                }
            });
        });
        return function(response) {
            return _ref.apply(this, arguments);
        };
    }()
};
var unauthorized = {
    canProcess: function(param) {
        var status = param.status;
        return status === HttpStatusCodes.UNAUTHORIZED;
    },
    process: function() {
        var _ref = _async_to_generator(function(response) {
            var event, error, _tmp;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event = new Event("helper:authorize", {
                            bubbles: true
                        });
                        document.dispatchEvent(event);
                        window["admin"].vent.trigger("helper:authorize");
                        _tmp = [
                            {}
                        ];
                        return [
                            4,
                            response.json()
                        ];
                    case 1:
                        error = _object_spread_props.apply(void 0, [
                            _object_spread.apply(void 0, _tmp.concat([
                                _state.sent()
                            ])),
                            {
                                status: response.status,
                                url: response.url
                            }
                        ]);
                        throw error;
                }
            });
        });
        return function(response) {
            return _ref.apply(this, arguments);
        };
    }()
};
var allOtherErrors = {
    canProcess: function() {
        return true;
    },
    process: function() {
        var _ref = _async_to_generator(function(response) {
            var error, _tmp, hasNoToken, ref, tokenIsInvalid, event, handleError;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = [
                            {}
                        ];
                        return [
                            4,
                            response.json()
                        ];
                    case 1:
                        error = _object_spread_props.apply(void 0, [
                            _object_spread.apply(void 0, _tmp.concat([
                                _state.sent()
                            ])),
                            {
                                status: response.status,
                                url: response.url
                            }
                        ]);
                        hasNoToken = (error === null || error === void 0 ? void 0 : error.errorCode) === "TOKEN_NOT_FOUND";
                        tokenIsInvalid = [
                            "InvalidToken",
                            "ExpiredToken"
                        ].includes((ref = error === null || error === void 0 ? void 0 : error.type) !== null && ref !== void 0 ? ref : null);
                        if (hasNoToken || tokenIsInvalid) {
                            event = new Event("helper:authorize", {
                                bubbles: true
                            });
                            document.dispatchEvent(event);
                            window["admin"].vent.trigger("helper:authorize");
                        } else {
                            handleError = Registry.get("error_handler");
                            handleError(error);
                        }
                        throw error;
                }
            });
        });
        return function(response) {
            return _ref.apply(this, arguments);
        };
    }()
};
export var ResponseHandlers = [
    PrivatePlatformClient.Handlers.noContent,
    PrivatePlatformClient.Handlers.success,
    offline,
    outOfService,
    unauthorized,
    allOtherErrors
];

//# sourceMappingURL=ResponseHandlers.js.map